export default {
    cptDataForm: {
        dataText: '{"value":1672506061000}',
        dataSource: 1, pollTime: 0, apiUrl: '/text', sql: 'select id from test limit 1'
    },
    attribute: {
        textColor: '#fff', fontSize: 18, fontWeight:'normal', fontFamily:'微软雅黑',
        dataType: 0,//0当前时间，1指定时间
        format: 'yyyy-MM-dd', showWeek: false,
        showDate: true, showTime: true, textAlign: 'center', hourType: 2
    },
}
